import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { BatchEntryService } from 'src/service/batch-entry.service';
import { FocusInputType, LocalService, BatchEntryInitialization, Status } from 'src/service/local.service';

@Component({
  selector: 'app-batch-entry',
  templateUrl: './batch-entry.component.html',
  styleUrl: './batch-entry.component.scss'
})
export class BatchEntryComponent {
  @ViewChild('content_batch_entry')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() businessId: string = '';
  @Input() id: string = '';
  isNoValidity: boolean = false; isAutoDeactive: boolean = true;

  message: string = ''; isRedAlert: boolean = true;

  batchEntryInitialization: BatchEntryInitialization;

  elementIds: any = {
    title: 'txt_batch_entry_title',
    save: "btn_batch_entry_save"
  };

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private batchEntryService: BatchEntryService) {
  }

  ngOnInit(): void {
    this.onInitiate();
  }

  onInitiate() {

  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.batchEntryService.getBatchEntryInitialization(this.businessId, this.id).subscribe(result => {
      this.batchEntryInitialization = result;
      this.isNoValidity = this.batchEntryInitialization.batchEntry.v5 == '1';
      this.isAutoDeactive = this.batchEntryInitialization.batchEntry.v6 == '1';
      setTimeout(() => {
        this.localService.onFocusNextInput(this.elementIds.title, FocusInputType.TextBox);
      }, 100);
    });
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {

      } break;
      case 2: {
        //Save product
        this.onSave();
      } break;
    }
  }

  onSave() {
    if (this.doCheck()) {
      this.batchEntryInitialization.batchEntry.v5 = this.isNoValidity ? '1' : '0';
      this.batchEntryInitialization.batchEntry.v6 = this.isAutoDeactive ? '1' : '0';
      this.batchEntryService.saveBatchEntry(this.batchEntryInitialization.batchEntry).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        switch (result.status) {
          case Status.Success: {
            this.onCloseTrigger();
          } break;
        }
      });
    }
  }

  doCheck() {
    let message = '';
    this.isRedAlert = true;
    let wrapper = this.batchEntryInitialization.batchEntry;

    if (!this.isNoValidity && (!wrapper.v3 || !wrapper.v3.trim())) {
      message = this.localService.languageContent.batch_entry.need_supplier;
    }

    this.message = message;
    if (this.message != '') {
      //this.localService.showInformation(this.message, this.isRedAlert);
    }
    return message == '';
  }

}
